import Style from './license-badge.tailwind.js';
import { LICENSE_TIERS } from 'views/shared.constants';

// Recognized tier labels, verbatim — everything LICENSE_TIERS offers as a
// filter except the pseudo-tier 'None', which means "no license".
const TIER_LABELS = LICENSE_TIERS.filter(label => label !== 'None');

export function LicenseBadge({ tiers }) {
  const arr = Array.isArray(tiers) ? tiers : tiers ? [tiers] : [];
  const validTiers = [...new Set(arr.filter(t => TIER_LABELS.includes(t)))];
  if (!validTiers.length) return <span className={Style.empty}>—</span>;
  return (
    <span style={{ display: 'inline-flex', gap: 4 }}>
      {validTiers.map((tier, idx) => {
        const cls = Style[tier.toLowerCase()];
        return <span key={`${tier}-${idx}`} className={`${Style.base} ${cls}`}>{tier}</span>;
      })}
    </span>
  );
}
